module.exports = __webpack_public_path__ + "img/aboutus-case2.ac7618ed.png";